module.exports = function( THREE ){

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	THREE.SavePass = function ( renderTarget ) {

		if ( THREE.CopyShader === undefined )
			console.error( "THREE.SavePass relies on THREE.CopyShader" );

		var shader = THREE.CopyShader;

		this.textureID = "tDiffuse";

		this.uniforms = THREE.UniformsUtils.clone( shader.uniforms );

		this.material = new THREE.ShaderMaterial( {

			uniforms: this.uniforms,
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader

		} );

		this.renderTarget = renderTarget;

		if ( this.renderTarget === undefined ) {

			this.renderTargetParameters = { minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter, format: THREE.RGBFormat, stencilBuffer: false };
			this.renderTarget = new THREE.WebGLRenderTarget( window.innerWidth, window.innerHeight, this.renderTargetParameters );

		}

		this.enabled = true;
		this.needsSwap = false;
		this.clear = false;


		this.camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
		this.scene  = new THREE.Scene();

		this.quad = new THREE.Mesh( new THREE.PlaneBufferGeometry( 2, 2 ), null );
		this.scene.add( this.quad );

	};

	THREE.SavePass.prototype = {

		render: function ( renderer, writeBuffer, readBuffer, delta ) {

			if ( this.uniforms[ this.textureID ] ) {

				this.uniforms[ this.textureID ].value = readBuffer;

			}

			this.quad.material = this.material;

			renderer.render( this.scene, this.camera, this.renderTarget, this.clear );

		}

	};

};



//////////////////
// WEBPACK FOOTER
// ./~/three-js/addons/SavePass.js
// module id = 450
// module chunks = 0